<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- This is the main wrapper for our dropdown menu -->
<div class="drop-down-menu-wrapper" [closeWhenIgnored]="opened$" (whenIgnored)="close($event)">
	<!-- Styling for our dropdown label (The text you click on to open/close the dropdown -->
	<div (click)="toggle()" class="drop-down-menu-label">
		<ng-content select="[dropdown-label]"></ng-content>
	</div>

	<!-- This contains our dropdown elements -->
	<div class="drop-down-menu" *ngIf="opened$ | async">
		<ng-content select="[dropdown-content]"></ng-content>
	</div>
</div>
